import SettingsWithContext from './SettingsWithContext';

export default {
  ReactComponent: SettingsWithContext,
  bindings: {
    user: '<',
    personaCollection: '<',
    saveClientFlags: '&',
    clientFlags: '<',
    tabs: '<',
    activeTab: '<',
    changeTab: '&',
    openPremiumGuardModal: '&',
    openPricingModal: '&',
    openLaborCostVideoModal: '&',
    laborCostSettings: '<',
    saveLaborCostSettings: '&',
    googleCalendarUtils: '<',
    timeOffTypes: '<',
    laborCostDataLoaded: '<',
    addEditDayPart: '&',
    addEditTimeBlock: '&',
    isWhitelisted: '<',
    setWebsocketCallback: '&',
    integrations: '<',
  },
  dependencies: ['ConnectCodeModal', 'IntegrationParametersModal', '$rootScope', '$state'],
};
